module.exports = "/_next/static/images/4a960895896ee2ebe130582037205d9c-savingsbanner-xs-1x.jpg";